import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles(() => ({
  root: {},
  radioGroup: {
    marginTop: 30,
  },
}));

export default useStyles;
